import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/MilitaryDiscountPage/militaryDiscountPage.js");
